import Cookies from 'js-cookie';

import getForcedBucket from '../utils/getForcedBucket';

const getWikiaBucketId = () => {
	const cookie = Cookies.get('exp_bucket');
	const newCookieFormatRegex = /^(?:v\d-)?(\d{2})/;

	if (cookie) {
		if (newCookieFormatRegex.test(cookie)) {
			return cookie;
		} else {
			return 'vN-' + cookie;
		}
	}

	return null;
};

/**
 * Gets the current bucket for user based on the following rules:
 *
 * - If the user is in a forced bucket, return that bucket.
 * - If the user is not in a forced bucket, return the bucket based on `getWikiaBucketId`.
 * - If bucket based on getWikiaBucketId is not available, use the default bucket `v5-100`.
 *
 * Returned bucket should not contain a part of the string that specifies the version of the bucketing system.
 */
export function getCurrentBucket(): string {
	const forcedBucket = getForcedBucket();

	const bucket = forcedBucket ?? getWikiaBucketId() ?? 'v5-100';

	const bucketValue = bucket.split('-').pop() ?? '';

	return bucketValue.padStart(2, '0');
}
